import React, { useState, useEffect } from "react";
import { Input } from "src/@/components/ui/input";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "src/@/components/ui/select";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { RadioGroup, RadioGroupItem } from "src/@/components/ui/radio-group";
import v2_actionConfigCrm from "src/actions/v2/crm/v2_actionConfigCrm";
import useAuth from "src/hooks/useAuth";

const CardChangeValue = ({ block, changeBlock }) => {
    const { cliente } = useAuth();
    const [selectedAction, setSelectedAction] = useState(block?.data?.funnelAction);
    const [configCrm, setConfigCrm] = useState(null);


    const labels = {
        1: "Sem interesse",
        2: "Frio",
        3: "Morno",
        4: "Esquentando",
        5: "Quente",
    };


    const radioItems = [
        { value: "valor", id: "valor", label: "Alterar Valor" },
        { value: "origem", id: "origem", label: "Alterar Origem" },
        { value: "qualificacao", id: "qualificacao", label: "Alterar Qualificação" },
        { value: "finalizar", id: "finalizar", label: "Finalizar Lead" },
        { value: "retomar", id: "retomar", label: "Retomar Lead" },
        { value: "marcarVenda", id: "marcarVenda", label: "Marcar Venda" },
        { value: "marcarPerda", id: "marcarPerda", label: "Marcar Perda" }
    ];

    
    async function buscarConfigCrm(querys) {
        try {
            const result = await v2_actionConfigCrm(cliente._id, querys);
            if (result.data.data) {
                setConfigCrm(result.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }



    return (
        <div className="w-full">
                <div className="space-y-6">
                    {/* Radio Group to select action */}
                    <div>
                        <label className="block text-sm font-bold mb-4">O que deseja fazer?</label>
                        <RadioGroup
                            className="flex flex-col gap-4"
                            value={block?.data?.funnelAction}
                            onValueChange={e => {
                                let event = {
                                    name: "funnelAction",
                                    value: e
                                }
                                changeBlock(event)
                                setSelectedAction(e)

                                if(e === "origem") {
                                    let querys = `?cliente_id=${cliente._id}`;
                                    buscarConfigCrm(querys);
                                }
                            }}
                        >
                            {radioItems.map(item => (
                                <div key={item.value} className="flex items-center gap-2">
                                    <RadioGroupItem value={item.value} id={item.value} />
                                    <label htmlFor={item.id} className="text-sm">{item.label}</label>
                                </div>
                            ))}
                        </RadioGroup>
                    </div>

                    {/* Conditional Render based on selected action */}
                    {selectedAction === "valor" && (
                        <div className="flex flex-col gap-1">
                            <label htmlFor="valor" className="text-sm font-medium">
                                Valor
                            </label>
                            <Input
                                type="text"
                                id="valor"
                                name="valor"
                                value={block?.data?.funnelValueLead}
                                onChange={e => {
                                    let event = {
                                        name: "funnelValueLead",
                                        value: e.target.value
                                    }
                                    changeBlock(event)
                                }}
                                placeholder="Digite o valor"
                            />
                        </div>
                    )}

                    {selectedAction === "origem" && (
                        <div className="flex flex-col gap-1">
                            <label htmlFor="origem" className="text-sm font-medium">
                                Origem
                            </label>
                            <Select value={block?.data?.origin} onValueChange={e => {
                                let event = {
                                    name: "origin",
                                    value: e
                                }
                                changeBlock(event)
                            }}>
                                <SelectTrigger>
                                    <SelectValue placeholder="Selecione a origem" />
                                </SelectTrigger>
                                <SelectContent>
                                    {
                                        configCrm?.origens.map((pipe) => (
                                            <SelectItem key={pipe._id} value={pipe._id}>
                                                {pipe.name}
                                            </SelectItem>
                                        ))
                                    }
                                </SelectContent>
                            </Select>
                        </div>
                    )}

                    {selectedAction === "qualificacao" && (
                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium">Qualificação</label>
                                <Input
                                    type="number"
                                    min="1"
                                    max="5"
                                    step="1"
                                    value={block?.data?.qualifyLead}
                                    onChange={(e) => {
                                        let event = {
                                            name: "qualifyLead",
                                            value:Number(e.target.value)
                                        }
                                        changeBlock(event)
                                    } }
                                    className="w-full"
                                />
                            </div>
                            <div className="text-sm text-gray-500">
                                <span>
                                    {labels[block?.qualifyLead] || "Selecione uma pontuação válida."}
                                </span>
                            </div>
                        </div>
                    )}

                    {selectedAction === "finalizar" && (
                        <div className="text-sm font-medium text-gray-700">
                            Finalizar Lead.
                        </div>
                    )}

                    {selectedAction === "retomar" && (
                        <div className="text-sm font-medium text-gray-700">
                            Retomar Lead.
                        </div>
                    )}

                    {selectedAction === "marcarVenda" && (
                        <div className="text-sm font-medium text-gray-700">
                            Marcar Venda
                        </div>
                    )}

                    {selectedAction === "marcarPerda" && (
                        <div className="text-sm font-medium text-gray-700">
                            Marcar Perda
                        </div>
                    )}
                </div>
        </div>
    );
};

export default CardChangeValue;
